import { alignRight as alignRight_1 } from './alignRight.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { Alignment } from 'roosterjs-editor-types';
import { setAlignment } from 'roosterjs-editor-api';

const alignRight: RibbonButton = {
    key: 'alignRight',
    title: () => loc(alignRight_1),
    imageSrc: require('../svg/alignright.svg'),
    onExecute: (plugin, logUsage) => {
        setAlignment(plugin.getEditor(), Alignment.Right);
        logUsage('setAlignment', Alignment.Right);
    },
};

export default alignRight;
